import { Entity } from '@data-client/rest';
class GeoTerritoryEntity extends Entity {
    constructor() {
        super(...arguments);
        this.id = 0;
        this.geoCountryId = 0;
        this.name = null;
        this.territoryCode = null;
    }
    pk() {
        return this.id.toString();
    }
}
GeoTerritoryEntity.key = 'GeoTerritory';
export { GeoTerritoryEntity };
